import { animated } from "@react-spring/web";
import React from "react";
import { useModalTransition } from "shared-components/ModalsAndDialogs/hooks";
import { useSampleState } from "../../state/hooks";
import { ContainerLineageModal } from "../ContainerLineageTable/Modal";
import { SampleModals } from "./model.enum";

export function SampleModalContent(): JSX.Element {
  const {
    sampleState: { currentModal },
  } = useSampleState();
  const transition = useModalTransition(currentModal);
  return transition((props, currentModal) => {
    switch (currentModal) {
      case SampleModals.LineageModal:
        return (
          <animated.div style={props}>
            <ContainerLineageModal />
          </animated.div>
        );
      default:
        return <React.Fragment />;
    }
  });
}
